(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["alr-card-info"] && !Shopify.designMode) return;
  try {
    /* Miniaturile „Mai multe opțiuni”: se cer doar pentru cardurile de pe ecran, când browserul e liber,
     printr-un șablon mic (?view=alr-sw) și se țin minte în sessionStorage. Pe conexiuni foarte lente
     (Economizor de date, 2G) nu se cer deloc: rămâne textul „Mai multe opțiuni”, cu link spre produs. */
  (() => {
    const conn = navigator.connection || {};
    const slow = conn.saveData || /(^|-)2g$/.test(conn.effectiveType || '');
    const KEY = 'alr_sw_v1';
    let store = {};
    try {
      store = JSON.parse(sessionStorage.getItem(KEY) || '{}');
    } catch (e) {}
    const save = () => {
      try {
        sessionStorage.setItem(KEY, JSON.stringify(store));
      } catch (e) {}
    };
    const pending = new Map();
    const root = window.Shopify?.routes?.root || '/';
    const load = (h) => {
      if (store[h]) return Promise.resolve(store[h]);
      if (!pending.has(h)) {
        pending.set(
          h,
          fetch(`${root}products/${encodeURIComponent(h)}?view=alr-sw`, { credentials: 'same-origin' })
            .then((r) => (r.ok ? r.json() : null))
            .then((d) => {
              if (d) {
                store[h] = d;
                save();
              }
              return d;
            })
            .catch(() => null)
        );
      }
      return pending.get(h);
    };
    const idle = window.requestIdleCallback || ((cb) => setTimeout(cb, 1));
    const fill = async (el) => {
      el.dataset.loaded = '1';
      const current = el.dataset.current;
      const handles = el.dataset.handles.split(',').filter(Boolean);
      const box = el.querySelector('.alr-card__thumbs');
      const items = await Promise.all(handles.map(load));
      const links = [];
      items.forEach((d, i) => {
        if (!d || !d.i) return;
        const a = document.createElement('a');
        a.href = d.u;
        a.title = d.t;
        if (handles[i] === current) a.setAttribute('aria-current', 'true');
        const img = document.createElement('img');
        img.src = d.i;
        img.alt = d.t;
        img.loading = 'lazy';
        img.decoding = 'async';
        img.width = 44;
        img.height = 44;
        a.append(img);
        links.push(a);
      });
      if (links.length < 2) {
        el.remove();
        return;
      }
      const max = window.matchMedia('(max-width: 749px)').matches ? 4 : 5;
      let shown = links;
      if (links.length > max) {
        const cur = links.find((a) => a.hasAttribute('aria-current'));
        shown = links.filter((a) => a !== cur).slice(0, max - 2);
        if (cur) shown.unshift(cur);
        else shown = links.slice(0, max - 1);
        const more = document.createElement('a');
        more.className = 'alr-card__more';
        more.href = cur ? cur.href : links[0].href;
        more.textContent = `+${links.length - shown.length}`;
        more.setAttribute('aria-label', `Încă ${links.length - shown.length} opțiuni`);
        shown.push(more);
      }
      box.replaceChildren(...shown);
    };
    const lite = (el) => {
      // net foarte lent: fără poze, doar câte opțiuni are produsul
      el.dataset.loaded = '1';
      const n = el.dataset.handles.split(',').filter(Boolean).length;
      const label = el.querySelector('.alr-card__sw-label');
      if (label) label.textContent = `${n} opțiuni de culoare sau mărime`;
      el.querySelector('.alr-card__thumbs')?.remove();
    };
    const io = slow
      ? null
      :
      'IntersectionObserver' in window
        ? new IntersectionObserver(
            (entries) => {
              entries.forEach((e) => {
                if (!e.isIntersecting) return;
                io.unobserve(e.target);
                idle(() => fill(e.target), { timeout: 1500 });
              });
            },
            { rootMargin: '200px' }
          )
        : null;
    const scan = () => {
      document.querySelectorAll('[data-alr-sw]:not([data-loaded]):not([data-watch])').forEach((el) => {
        el.dataset.watch = '1';
        if (slow) lite(el);
        else if (io) io.observe(el);
        else idle(() => fill(el));
      });
    };
    let queued = false;
    const queue = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        scan();
      });
    };
    scan();
    // cardurile noi (filtre, „încarcă mai multe”) apar în grila de produse; urmărim doar zona principală, cu o
    // singură scanare pe cadru, nu la fiecare schimbare din pagină
    const zone = document.querySelector('main') || document.body;
    new MutationObserver(queue).observe(zone, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["proveni-surori"] && !Shopify.designMode) return;
  try {
    // Cu „Fără reîncărcare”: pagina surorii se aduce în fundal (Section Rendering API) și înlocuiește doar secțiunea
  // produsului; adresa și titlul paginii se schimbă ca la o pagină nouă. Linkul rămâne adevărat: la orice eroare
  // (sau cu Ctrl/Cmd apăsat) browserul deschide pagina obișnuit.
  if (!customElements.get('proveni-surori')) {
    customElements.define(
      'proveni-surori',
      class extends HTMLElement {
        connectedCallback() {
          this.addEventListener('click', this.#laClick);
        }

        disconnectedCallback() {
          this.removeEventListener('click', this.#laClick);
        }

        #laClick = async (event) => {
          const link = event.target.closest('a[data-proveni-sora]');
          if (!link || !this.hasAttribute('data-fara-reincarcare')) return;
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
          event.preventDefault();
          if (link.getAttribute('aria-current') === 'page') return;

          const idSectiune = this.dataset.sectionId;
          const sectiune = document.getElementById(`shopify-section-${idSectiune}`);
          if (!sectiune) return (window.location.href = link.href);

          this.setAttribute('aria-busy', 'true');
          try {
            const url = new URL(link.href, window.location.origin);
            url.searchParams.set('section_id', idSectiune);
            const raspuns = await fetch(url, { credentials: 'same-origin' });
            if (!raspuns.ok) throw new Error(String(raspuns.status));
            const doc = new DOMParser().parseFromString(await raspuns.text(), 'text/html');
            const noua = doc.getElementById(`shopify-section-${idSectiune}`);
            if (!noua) throw new Error('secțiunea lipsește');
            sectiune.innerHTML = noua.innerHTML;
            window.history.pushState({ proveniSurori: true }, '', link.href);
            if (link.dataset.titlu) document.title = link.dataset.titlu;
          } catch (eroare) {
            window.location.href = link.href;
          }
        };
      }
    );

    // înapoi/înainte după o schimbare fără reîncărcare: pagina se încarcă din nou, la adresa corectă
    window.addEventListener('popstate', (event) => {
      if (event.state && event.state.proveniSurori) window.location.reload();
    });
    if (!window.history.state) window.history.replaceState({ proveniSurori: true }, '');
  }
  } catch(e) { console.error(e); }
})();

})();
